import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../wf/interface/wf-activity-registry';
import {
    TmTicketWfProcessStepActivityComponent
} from './component/protected-components/wf/tm-ticket-wf-process-step-activity/tm-ticket-wf-process-step-activity.component';

export const TM_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['ticket_create', {mainComponent: TmTicketWfProcessStepActivityComponent}],
        ['ticket_status', {mainComponent: TmTicketWfProcessStepActivityComponent}],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
